import styled from 'styled-components';
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';

interface TextProps
  extends ColorProps,
    TypographyProps,
    SpaceProps,
    LayoutProps {
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  ref?: React.Ref<HTMLElement>;
}

const Text = styled.p.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop),
})<TextProps>`
  ${color}
  ${typography}
  ${space}
  ${layout}
`;

export default Text;
